// @flow
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Divider from "@material-ui/core/Divider";
import type { MapConfig, MapSource } from '../../../types';
import SourceItem from './SourceItem';

type Props = $ReadOnly<{
    sources: $ReadOnly<{[id: string]: MapSource}>,
    activeId?: string,

    onChange: (sources: $PropertyType<MapConfig, 'sources'>) => void,
    onPreview: (sourceId: string) => void,
    onActivate: (sourceId: string) => void
}>;
function SourceList({ sources, activeId, onChange, onPreview, onActivate }: Props) {
    const sourceIds = Object.keys(sources);

    const handleDelete = (sourceId) => {
        const newSources = {
            ...sources
        };

        delete newSources[sourceId];

        onChange(newSources);
    };

    if(sourceIds.length === 0) {
        return (
            <FormattedMessage
                id="mapSource.noSources"
                defaultMessage="No sources"
            />
        );
    }

    return (
        <React.Fragment>
            {sourceIds.map((sourceId, index) => (
                <React.Fragment key={index}>
                    <SourceItem
                        sourceId={sourceId}
                        source={sources[sourceId]}
                        active={sourceId === activeId}
                        onPreview={onPreview}
                        onDelete={handleDelete}
                        onActivate={onActivate}
                    />
                    <Divider />
                </React.Fragment>
            ))}
        </React.Fragment>
    );
}

export default SourceList;